<template>
    <div class="list">
        <div v-if="!loading">
            <div class="open_answer">
                <div class="left_part">
                    <div class="left_part_title">是否开放答案</div>
                    <div class="left_part_tip">{{openAnswer?"关闭之后，学生在核对答案时将无法看到答案内容。":"开启之后，学生在核对答案时候将会看到答案内容。"}}</div>
                </div>
                <div @click="toggleOpenStatus"
                     :class="['right_part',{'open':openAnswer}]"></div>
            </div>
            <div class="history"
                 v-if="history&&history.length">
                <p>浏览记录</p>
                <div v-for="(item,index) in history">
                    <span class="icon"></span>
                    <span class="name"
                          @click="go(item)">{{item.str}}</span>
                    <span class="btn"
                          @click="dele(index)"></span>
                </div>
            </div>
            <ul class="clearfix"
                v-if="listYW.length>0">
                <h3>语文部编版</h3>
                <li @click="tochapter(51,book)"
                    v-for="book in listYW">{{book.grade_name}}</li>
            </ul>
            <ul class="clearfix"
                v-for="list in listSX"
                v-if="listSX.length>0">
                <h3>数学{{list.press_name}}</h3>
                <li v-for="book in list.list"
                    @click="tochapter(book.subject_id,book)">{{book.grade_name}}</li>
            </ul>
        </div>
        <loadingS v-else></loadingS>
    </div>
</template>
<script>
import loadingS from 'COMPONENTS/base/tealoading.vue';
export default {
    data () {
        return {
            listYW: [],
            listSX: [],
            userId: "",
            historyKey: 'xcplook',
            data: {
                userId: '',
                list: []
            },
            history: [],
            loading: true,
            openAnswer: false
        }
    },
    components: {
        loadingS
    },
    async created () {
        this.userId = JSON.parse(localStorage.getItem("info")).user_id;
        if (localStorage.getItem(this.historyKey)) {
            this.data = JSON.parse(localStorage.getItem(this.historyKey));
            if (this.data.list && this.userId == this.data.userId) {
                this.history = this.data.list;
            } else {
                localStorage.removeItem("xcplook");
            }
        }
        this.$http.post(API_URL_TASK_API + '/maths/check/book/bz/').then(res => {
            this.loading = false;
            if (res.data.response === "ok") {
                this.listYW = res.data.data.yw; //语文
                this.listSX = this.getBook(res.data.data.sx);//数学
                this.openAnswer = res.data.data.is_show_answer;
            }
        })
    },
    methods: {
        // 浏览记录
        go (item) {
            this.$router.push(`/hnPaper/chapter/${item.sid}/${item.bookId}`);
        },
        toggleOpenStatus () {
            layer.open({ type: 2, shadeClose: false });
            this.$http.post(API_URL_TASK_API + '/public/task/set_open_answer', { status: this.openAnswer ? 0 : 1 }).then(res => {
                layer.closeAll();
                if (res.data.response === "ok") {
                    this.openAnswer = !this.openAnswer;
                }
            })
        },
        //查看报纸
        tochapter (sid, book) {
            // 记录查看过的报纸
            let o = {
                bookId: book.id,
                sid: sid, //语文没有subject_id
                str: (sid == 21 || sid == 22) ? book.grade_name + '-' + book.press_name + '-' + '数学' : book.grade_name + '-人教部编版-语文'
            };
            let same = false;
            if (this.history && this.history.length > 0) {
                for (let i = 0; i < this.history.length; i++) {
                    let _o = this.history[i];
                    if (_o.bookId == book.id) {
                        same = true;
                        break;
                    }
                }
            }
            if (!same) {
                this.history.push(o);
            }
            this.data = {
                userId: this.userId,
                list: this.history
            }
            this.setlocal();
            let { platform, app_version } = JSON.parse(localStorage.getItem('search'));
            this.$router.push(`/hnPaper/chapter/${sid}/${book.id}?platform=${platform}&app_version=${app_version}`);
        },
        //根据数据类型分组
        getBook (array) {
            let _array = [];
            let _press_name = "";
            let i = 0;
            let isinIt = false;
            array.filter((item, index) => {
                isinIt = false;// 默认不存在
                _array.filter((it) => {
                    if (it.press_name == item.press_name) { //教材相同对应存入数组
                        isinIt = true; //存在相同名称的直接存入数组记录
                        it.list.push(item)
                    }
                })
                if (!isinIt) { //不存在相同名称存入新的数组
                    let data = {
                        press_name: item.press_name,
                        list: []
                    }
                    data.list.push(item) //把数据导入对应数组
                    _array[i] = data;
                    i++;
                }
            })
            return _array;
        },
        dele (i) {
            layer.open({
                content: '是否删除此条浏览记录？'
                , btn: ['确定', '取消']
                , yes: (index) => {
                    this.history.splice(i, 1);
                    this.data.list = this.history;
                    this.setlocal();
                    layer.close(index);
                }
            });
        },
        // 记录缓存
        setlocal () {
            localStorage.setItem(this.historyKey, JSON.stringify(this.data));
        }
    },
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
@import "./src/assets/scss/common/_mixin";
.open_answer {
    height: 158px / $ppr;
    background-color: #fff;
    padding: 0 32px / $ppr 0 24px / $ppr;
    display: flex;
    align-items: center;
    .left_part {
        flex-grow: 1;
        .left_part_title {
            font-size: 30px / $ppr;
            line-height: 56px / $ppr;
        }
        .left_part_tip {
            color: #999;
            font-size: 24px / $ppr;
            line-height: 50px / $ppr;
        }
    }
    .right_part {
        width: 100px / $ppr;
        height: 58px / $ppr;
        background-image: url("./img/icon06.png");
        background-size: 100% 100%;
        cursor: pointer;
        &.open {
            background-image: url("./img/icon05.png");
        }
    }
}
.history {
    width: 100%;
    font-size: 28px / $ppr;
    margin-bottom: 30px / $ppr;
    p {
        line-height: 80px / $ppr;
        height: 80px / $ppr;
        padding-left: 28px / $ppr;
        padding-top: 12px / $ppr;
    }
    div {
        background: #fff;
        width: 624px / $ppr;
        margin: 0 auto;
        padding: 0 24px / $ppr;
        height: 96px / $ppr;
        position: relative;
        z-index: 1;
        border-bottom: 1px / $ppr solid #f0f0f0;
        &:last-child {
            border: none;
        }
        span {
            display: inline-block;
            line-height: 96px / $ppr;
            height: 96px / $ppr;
            vertical-align: middle;
            &.icon {
                width: 34px / $ppr;
                height: 33px / $ppr;
                background: url("./img/icon01.png");
                background-size: 100% 100%;
            }
            &.name {
                width: 420px / $ppr;
                // border:1px solid #333;
                color: #999;
                padding-left: 16px / $ppr;
            }
            &.btn {
                width: 120px / $ppr;
                height: 48px / $ppr;
                background: url("./img/icon02.png");
                background-size: 100% 100%;
                position: absolute;
                z-index: 2;
                top: 50%;
                right: 24px / $ppr;
                margin-top: -24px / $ppr;
            }
        }
    }
}
.list {
    width: 100%;
}
ul {
    width: 672px / $ppr;
    margin: 0 auto;
    padding: 0 0 16px / $ppr;
    text-align: center;
    h3 {
        font-size: 32px / $ppr;
        color: #5e89ef;
        // line-height:42px/$ppr;
        // height:42px/$ppr;
        line-height: 100px / $ppr;
        height: 100px / $ppr;
        position: relative;
        vertical-align: middle;
        // margin-bottom:32px/$ppr;
        &::before,
        &::after {
            display: inline-block;
            content: "";
            width: 36px / $ppr;
            height: 16px / $ppr;
        }
        &::before {
            background: url("./img/left.png");
            background-size: 100% 100%;
            margin-right: 16px / $ppr;
        }
        &::after {
            background: url("./img/right.png");
            background-size: 100% 100%;
            margin-left: 16px / $ppr;
        }
    }
    li {
        width: 324px / $ppr;
        line-height: 88px / $ppr;
        height: 88px / $ppr;
        text-align: center;
        font-size: 30px / $ppr;
        color: #333;
        background: #fff;
        border-radius: 5px / $ppr;
        margin-bottom: 24px / $ppr;
        &:nth-child(odd) {
            float: right;
        }
        &:nth-child(even) {
            float: left;
        }
    }
}
</style>